import { Component, OnInit } from '@angular/core';
import { AppService, DomainDetails } from 'src/app/app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  public domainDetails: DomainDetails;
  constructor(
    public appService: AppService,
    public router: Router
  ) { }

  ngOnInit() {
    this.domainDetails = this.appService.DOMAIN_DETAILS();
  }

  goToLoginPage() {
    this.router.navigate(['/login']);
  }
}
